import React from "react";
import { ScrollArea } from "../../../../components/ui";

export const OrderLotteryGallery = ({ lotteries = [] }) => {
  if (!lotteries || lotteries.length === 0) return null;

  return (
    <div className="border border-slate-200 rounded-md overflow-hidden bg-slate-50/50 mb-4">
      <ScrollArea className="py-2.5" orientation="horizontal">
        <div className="flex items-center w-max space-x-3 px-3">
          {lotteries.map((lottery, index) => (
            <div
              key={lottery.id || index}
              className="relative flex items-center rounded-md overflow-hidden border border-slate-200 shadow-xs bg-white"
            >
              <div className="absolute top-0 left-0">
                <span className="flex items-center justify-center text-sm font-bold text-white w-7 h-7 bg-slate-900/80 rounded-br-md">
                  {lotteries.length - index}
                </span>
              </div>
              {lottery.donate && (
                <span className="absolute bottom-0 left-0 right-0 py-1 px-2 text-xs font-semibold bg-blue-900/85 text-white text-center">
                  +1 บาท ร่วมบริจาคน้ำท่วม
                </span>
              )}
              <img
                src={lottery.image}
                alt={lottery.id || `lottery-${index}`}
                className="h-32 object-contain"
              />
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};
